export default __webpack_public_path__ + "static/0159-ad6f449f5412c4deb54889f9b8bd7601.png";